import Badge from "features/classroom/common/Badge/Badge";
import TextPlaceholder from "features/common/components/TextPlaceholder";

import { RowLayout } from "../RowLayout";
import { SidebarContentWrapperInner } from "../SidebarContentWrapper";
import styles from "./SectionRowLoading.module.scss";

export default function SectionRowLoading() {
  return (
    <SidebarContentWrapperInner>
      <RowLayout depth={0}>
        {{
          title: (
            <TextPlaceholder
              displayInlineBlock
              placeholderWidth="180px"
              className={styles.text}
              loading
            />
          ),
          indicator: <Badge count={null} loading />
        }}
      </RowLayout>
    </SidebarContentWrapperInner>
  );
}
